import React from "react";
import { Avatar } from "antd";
import { getContactInitials } from "helpers/getContactInitials";
import { AVATAR_COLORS } from "constants/AvatarDisplayConstant";

const avatarStyle = {
  borderRadius: "60px",
  width: "60px",
  height: "60px",
};

const hashInitials = (initials) => {
  let hash = 0;
  for (let i = 0; i < initials.length; i++) {
    hash = (hash * 31 + initials.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

const generateHSL = (initials, isBgColor) => {
  const seed = hashInitials(initials || "?");
  const h = seed % 360;
  const s = 40 + (seed % 21);
  const l = isBgColor
    ? AVATAR_COLORS.L_BACKGROUND_COLOR
    : AVATAR_COLORS.L_FONT_COLOR;
  return `hsl(${h},${s}%,${l}%)`;
};

const AvatarDisplay = ({
  image,
  customStyle,
  name,
  tableAvatar,
  containerStyle,
}) => {
  const initials = getContactInitials(name);

  return (
    <div
      className={
        tableAvatar ? "" : `image-container avatar-container ${containerStyle}`
      }
    >
      {image ? (
        <img style={{ ...avatarStyle, ...customStyle }} src={image} alt="" />
      ) : (
        <Avatar
          style={{
            fontWeight: "bold",
            color: generateHSL(initials, false),
            backgroundColor: generateHSL(initials, true),
            ...customStyle,
          }}
          className="d-flex align-items-center justify-content-center"
        >
          {initials}
        </Avatar>
      )}
    </div>
  );
};

AvatarDisplay.defaultProps = {
  customStyle: {},
  name: "",
  containerStyle: "",
};

export default AvatarDisplay;
